import React from "react";
import { Button, Col, Dropdown, Row, Tooltip, type MenuProps } from "antd";
import { DownloadOutlined, DownOutlined, EyeOutlined, ReloadOutlined } from "@ant-design/icons";
import type { IntlShape } from "react-intl";

import moduleStyles from "../document.module.css";

interface FreightGridToolbarProps {
    extraActions?: React.ReactNode;
    intl: IntlShape;
    menuItems: MenuProps["items"];
    onExport: () => void;
    onResetView: () => void;
}

const FreightGridToolbar: React.FC<FreightGridToolbarProps> = ({
    extraActions,
    intl,
    menuItems,
    onExport,
    onResetView,
}) => {
    return (
        <Row gutter={16} className={moduleStyles.documentsToolbarRow}>
            <Col className={moduleStyles.documentsToolbarCol}>
                <div className={moduleStyles.freightToolbarGroup}>
                    <Dropdown.Button
                        data-testid="view-result-customization"
                        menu={{ items: menuItems }}
                        trigger={["click"]}
                        icon={<DownOutlined />}
                        size="middle"
                    >
                        <EyeOutlined />
                        {intl.formatMessage({ id: "info-portal-view", defaultMessage: "View" })}
                    </Dropdown.Button>

                    <Tooltip title={intl.formatMessage({ id: "reset-filter" })}>
                        <Button
                            data-testid="view-result-customization-reset"
                            onClick={onResetView}
                            size="middle"
                            icon={<ReloadOutlined className={moduleStyles.simpleFlipRefresh} />}
                        >
                            {intl.formatMessage({ id: "info-portal-reset" })}
                        </Button>
                    </Tooltip>
                    {extraActions}
                    <Tooltip title={intl.formatMessage({ id: "export-to-excel", defaultMessage: "Export to Excel" })}>
                        <Button
                            data-testid="info-portal-export-excel"
                            icon={<DownloadOutlined />}
                            onClick={onExport}
                            size="middle"
                        >
                            {intl.formatMessage({ id: "export", defaultMessage: "Export" })}
                        </Button>
                    </Tooltip>
                </div>
            </Col>
        </Row>
    );
};

export default FreightGridToolbar;